import * as React from "react";
import { PatientPersonalInformation } from "@curefit/ups-common";
import {default as EditViewCard, EditViewDisplayMode} from "../../components/common/EditViewCard";
import IinfoQues from "../../models/staticData/IinfoQues";
import IDishCatalogueResponse from "../../models/maverick/IDishCatalogueResponse";

/**
 * Created by Prachi on 02/04/18.
 */

interface DetailsContProps {
    details: PatientPersonalInformation;
    staticPersonalInfo: IinfoQues;
    displayMode?: EditViewDisplayMode,
    fetchDishByDishName?: (input: string) => Promise<IDishCatalogueResponse[]>
}
interface DetailsContStates {
    details: PatientPersonalInformation;
}
export default class DetailsEditViewCont extends React.Component<DetailsContProps, DetailsContStates> {
    constructor(props: DetailsContProps) {
        super(props);
        this.state = {details: props.details};
    }
    getDetailsEditViewProps = () => {
        let editProps = {
            staticPersonalInfo: {...this.props.staticPersonalInfo},
            details: {...this.state.details},
            updateDetailsInfo: this.updateDetailsInfo,
            fetchDishByDishName: this.props.fetchDishByDishName
        }
        return {"view": {}, "edit": {...editProps}};
    }
    saveDetailsInfo = () => {
        // Save Patient Personal Info
    }
    updateDetailsInfo = (details: PatientPersonalInformation, key: string) => {
        if (key === "goalPreferences") {
            let answers = this.props.staticPersonalInfo.questionnaire.filter(question => question.key === "goalPreferences")[0].answerList[0].values.filter(value => value.internalValue === details.goalPreferences.goalInternalValue);
            let updatedValues = answers.map(answer => { return { goalInternalValue: answer.internalValue, goalDisplayValue: answer.displayValue, meta: {} } });
            details.goalPreferences = updatedValues;
        }
        this.setState({details: details});
    }
    getSaveObject = () => {
        let detailsInfo = {...this.state.details};
        return detailsInfo;
    }
    cancelActionHandler = () => {}
    render() {
        return <div>
            <EditViewCard cardTitleDisplay={"Details"} templateName={"details"}
                          templateProps={this.getDetailsEditViewProps()}
                          lastEditedEpoch={new Date().getTime()} saveActionHandler={this.saveDetailsInfo}
                          cancelActionHandler={this.cancelActionHandler}
                          displayMode={this.props.displayMode}
            />
        </div>
    }
}